import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { RouterModule } from "@angular/router";
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataTableModule } from "angular2-datatable";
import { MovimientosVamService } from "./movimientosVam.service";
import { MovimientosVamComponent } from "./movimientosVam.component";
import { CalendarModule } from 'primeng/primeng';


@NgModule({
    declarations: [MovimientosVamComponent],
    imports: [BrowserModule, HttpModule, FormsModule, BrowserAnimationsModule, RouterModule, DataTableModule,CalendarModule],
    exports: [MovimientosVamComponent],
    providers: [MovimientosVamService]
})

export class MovimientosVamModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/movimientos/movimientosVam.module.ts